import * as React from 'react'
import { Card, CardContent, CardHeader } from '@mui/material'
import { RouteLink } from './RouteLink'

export function RouterMenu({
  menuTitle,
  routes,
}: {
  menuTitle: string
  routes: { key: string; title: string; description: string }[]
}) {
  return (
    <Card>
      <CardHeader title={menuTitle} />
      <CardContent>
        {routes.map((r) => {
          return <RouteLink key={r.key} route={r} />
        })}
      </CardContent>
    </Card>
  )
}
